// components/Breadcrumbs.tsx
import Link from "next/link";

type Crumb = { label: string; href?: string };

type Props = {
    items: Crumb[];
    separator?: string;
    className?: string;
    itemClassName?: string;
    linkClassName?: string;
    currentClassName?: string;
    separatorClassName?: string;
};

export default function Breadcrumbs({
                                        items,
                                        className = "",
                                        itemClassName = "",
                                        linkClassName = "",
                                        currentClassName = "",
                                        separatorClassName = "",
                                    }: Props) {
    if (!items?.length) return null;

    return (
        <nav aria-label="Breadcrumb" className={''}>
            <ul className="flex gap-[1.2rem] py-[0.2rem] overflow-x-auto overflow-y-hidden">
                {items.map((item, i) => {
                    const isLast = i === items.length - 1;
                    return (
                        <li key={`${item.label}-${i}`} className="flex whitespace-nowrap">
                            {isLast || !item.href ? (
                                <span aria-current="page" className={`text-dark-blue text-breadcrumbs`}>{item.label}</span>
                            ) : (
                                <Link href={item.href} className={` hover:opacity-80 transition-opacity text-dusty-green-dark text-link`}>{item.label}</Link>
                            )}

                            {!isLast && (<span><span className={`text-dusty-green-dark select-none text-breadcrumbs`} aria-hidden="true"></span><span className="text-dusty-green-dark select-none text-breadcrumbs">/</span></span>)}
                        </li>
                    );
                })}
            </ul>
        </nav>
    );
}
